module.exports = __webpack_public_path__ + "static/media/projects.b7329985.svg";